import * as styles from "./index.css";

export default function Index() {
  return <div className={styles.header}>Welcome to Auth service!</div>;
}
